/* Inkfold card tilt
   Subtle 3D parallax: cards tilt towards the cursor on hover.
   Auto-applies to cards with [data-vs-tilt] OR these default selectors.
*/
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia && window.matchMedia('(hover: none)').matches) return; // Skip on touch devices

  const SELECTORS = [
    '.vs-pillar',
    '.vs-coming-card',
    '.vs-card',                  // product cards
    '.vs-testimonial',
    '.vs-blog-card',
  ];

  const MAX_TILT = 6;  // degrees
  const PERSPECTIVE = 1000; // px

  function attach(el) {
    el.style.transformStyle = 'preserve-3d';
    el.style.willChange = 'transform';

    let rafId = null;

    function onMove(e) {
      const rect = el.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      const cx = rect.width / 2;
      const cy = rect.height / 2;
      const rx = ((y - cy) / cy) * -MAX_TILT;
      const ry = ((x - cx) / cx) *  MAX_TILT;

      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        el.style.transform = `perspective(${PERSPECTIVE}px) rotateX(${rx.toFixed(2)}deg) rotateY(${ry.toFixed(2)}deg) translateZ(0)`;
      });
    }

    function onLeave() {
      if (rafId) cancelAnimationFrame(rafId);
      el.style.transform = '';
    }

    el.addEventListener('mousemove', onMove);
    el.addEventListener('mouseleave', onLeave);
  }

  // Defer to next frame so we don't compete with first paint
  requestAnimationFrame(() => {
    SELECTORS.forEach((sel) => {
      document.querySelectorAll(sel).forEach(attach);
    });
  });
})();
